import { type Phone } from 'services'

export const isPhoneNumberEmpty = (phone: Phone | null): boolean => {
  return phone?.phoneNumber == null || phone.phoneNumber === ''
}
